import { Dialog } from '@/components/UI/Dialog'
import { HtmlContent } from '@/components/UI/HtmlContent'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  usage: string
  isOpen: boolean
  onClose: () => void
}

/** 遊び方ダイアログ */
export const DialogCampaignHowToPlay = memo(({ usage, isOpen, onClose }: Props) => {
  const { t } = useTranslation()
  return (
    <Dialog selectorState={isOpen} closeFunc={onClose} title={t('how_to_play.how_to_play', '遊び方')}>
      {/*
        usage は管理画面の WYSIWYG（TinyMCE）が出力した HTML。概要ダイアログと同じ扱いにする（#3609）。
        改行は <br> / 段落で表現されるため、whitespace-pre-wrap は付けない。
        付けると TinyMCE がブロック間に入れる改行コードまで改行として表示され、段落やリストの間に空行が出る
      */}
      <HtmlContent html={usage} variant="body1" className="mt-4 text-gray-700" />
    </Dialog>
  )
})
